import { m } from 'framer-motion';
import { usePopover } from 'minimal-shared/hooks';

import Box from '@mui/material/Box';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';

import { useTranslate } from 'src/locales';

import { Iconify } from '../iconify';
import { CustomPopover } from '../custom-popover';
import { varTap, varHover, transitionTap } from '../animate';

// ----------------------------------------------------------------------

export function ButtonMoreOptions({ preview, product, sx, ...other }) {
  const { t } = useTranslate();

  const menuActions = usePopover();

  const renderMenuActions = () => (
    <CustomPopover
      open={menuActions.open}
      onClose={menuActions.onClose}
      anchorEl={menuActions.anchorEl}
      slotProps={{ arrow: { placement: 'right-bottom' } }}
    >
      <MenuList>
        <MenuItem onClick={() => console.log(product.id)}>
          <Iconify icon="solar:danger-bold" sx={{ color: 'error.main' }} />
          {t('Report content')}
        </MenuItem>
      </MenuList>
    </CustomPopover>
  );

  return (
    <Box
      sx={[
        {
          textAlign: 'center',
          color: 'common.white',
          filter: 'drop-shadow(0 1px 1px rgba(0, 0, 0, .24))',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <IconButton
        size="small"
        color="inherit"
        whileTap={varTap()}
        component={m.button}
        whileHover={varHover(1.08)}
        transition={transitionTap()}
        onClick={() => !preview && menuActions.onOpen()}
        {...other}
      >
        <Iconify
          icon="eva:more-vertical-fill"
          sx={{ width: { xs: 32, md: 26 }, height: { xs: 32, md: 26 } }}
        />
      </IconButton>

      {renderMenuActions()}
    </Box>
  );
}
